export const FETCH_BULK_ACTION_LIST_SUCCESS = 'FETCH_BULK_ACTION_LIST_SUCCESS';
export const FETCH_BULK_ACTION_LIST_REQUEST = 'FETCH_BULK_ACTION_LIST_REQUEST';
export const FETCH_BULK_ACTION_LIST_FAILURE = 'FETCH_BULK_ACTION_LIST_FAILURE';
export const FETCH_BULK_ACTION_LIST_REST = 'FETCH_BULK_ACTION_LIST_REST';
export const fetchBulkActionListSuccess = (payload) => ({
    type: FETCH_BULK_ACTION_LIST_SUCCESS,
    payload,
});
export const fetchBulkActionListRequest = (payload) => ({
    type: FETCH_BULK_ACTION_LIST_REQUEST,
    payload,
});
export const fetchBulkActionListFailure = (payload) => ({
    type: FETCH_BULK_ACTION_LIST_FAILURE,
    payload,
});
export const fetchBulkActionListReset = () => ({
    type: FETCH_BULK_ACTION_LIST_REST,
});
